import { render, staticRenderFns } from "./addAddressSection.vue?vue&type=template&id=50a40df3&scoped=true&"
import script from "./addAddressSection.vue?vue&type=script&lang=js&"
export * from "./addAddressSection.vue?vue&type=script&lang=js&"
import style0 from "./addAddressSection.vue?vue&type=style&index=0&id=50a40df3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a40df3",
  null
  
)

export default component.exports